import { create } from 'zustand';

interface AppState {
  toast: { message: string, type: 'success' | 'error' | 'info' } | null;
  setToast: (toast: { message: string, type: 'success' | 'error' | 'info' } | null) => void;
  theme: string;
  resolvedTheme: 'light' | 'dark';
  setTheme: (theme: string) => void;
}

const getResolvedTheme = (theme: string): 'light' | 'dark' => {
  if (theme === 'system') {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  }
  return theme === 'dark' ? 'dark' : 'light';
};

const initialTheme = localStorage.getItem('MamaPDF-theme') ?? 'system';

export const useAppStore = create<AppState>()((set) => ({
  toast: null,
  setToast: (toast) => { set({ toast }); },
  theme: initialTheme,
  resolvedTheme: getResolvedTheme(initialTheme),
  setTheme: (theme) => {
    localStorage.setItem('MamaPDF-theme', theme);
    const resolved = getResolvedTheme(theme);
    set({ theme, resolvedTheme: resolved });
  },
}));
